import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { Language } from '../i18n/translations';

export const LanguageSwitcher: React.FC = () => {
    const { language, setLanguage } = useLanguage();

    return (
        <div className="fixed top-4 right-4 z-50 flex gap-2">
            <button
                onClick={() => setLanguage('ru')}
                className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                    language === 'ru'
                        ? 'text-white shadow-lg'
                        : 'bg-white/80 text-gray-700 hover:bg-white/90 backdrop-blur-sm border border-gray-200'
                }`}
                style={language === 'ru' ? { backgroundColor: '#127BEB' } : {}}
            >
                RU
            </button>
            <button
                onClick={() => setLanguage('en')}
                className={`px-4 py-2 rounded-lg font-medium transition-all duration-200 ${
                    language === 'en'
                        ? 'text-white shadow-lg'
                        : 'bg-white/80 text-gray-700 hover:bg-white/90 backdrop-blur-sm border border-gray-200'
                }`}
                style={language === 'en' ? { backgroundColor: '#127BEB' } : {}}
            >
                EN
            </button>
        </div>
    );
};
